import React from "react";
import { Box, FormControlLabel, Switch, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const AndriodSwitch = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Filled Switch
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          switch thumb inside switch track.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Filled Variant of switch "}
          language={"js"}
          value={"      <FormControlLabel\n" +
              "            control={\n" +
              "              <Switch variant={\"filled\"} color={\"primary\"} defaultChecked disabled />\n" +
              "            }\n" +
              "            label=\"Medium\"\n" +
              "          />\n" +
              "          <FormControlLabel\n" +
              "            control={\n" +
              "              <Switch variant={\"filled\"} color={\"primary\"} size={\"small\"} defaultChecked />\n" +
              "            }\n" +
              "            label=\"Small\"\n" +
              "          />"}
        >
          <FormControlLabel
            control={
              <Switch variant={"filled"} color={"primary"} defaultChecked disabled />
            }
            label="Medium"
          />
          <FormControlLabel
            control={
              <Switch variant={"filled"} color={"primary"} size={"small"} defaultChecked />
            }
            label="Small"
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default AndriodSwitch;
